import { useMutation, gql, MutationHookOptions } from "@apollo/client";
import {
  CampaignMinimalFragment,
  CAMPAIGN_MINIMAL_FRAGMENT,
} from "../../fragments";
import { InsertCampaignMutationVariables } from "../../types";

export const INSERT_CAMPAIGN = gql`
  mutation insertCampaign($input: InsertCampaignInput!) {
    insertCampaign(input: $input) {
      campaign {
        ...CampaignMinimalFragment
      }
    }
  }

  ${CAMPAIGN_MINIMAL_FRAGMENT}
`;

export type CampaignData = {
  campaign: CampaignMinimalFragment;
};

export default (
  options?: MutationHookOptions<
    CampaignData,
    InsertCampaignMutationVariables
  >
) => {
  return useMutation<
    CampaignData,
    InsertCampaignMutationVariables
  >(INSERT_CAMPAIGN, options);
};
